import { all, takeLeading, call, put } from '@redux-saga/core/effects';
import axios from 'axios';

import { ERROR, SUCCESS } from '../../../utils/constants';
import { getErrorMessage } from '../../../utils/api-util';

import { requestViewStaff, requestUpdateUserGroups, requestPopulateDropdowns } from './admin-user-role.actions';
import {
  getViewStaffRequest,
  getUpdateUserGroupsRequest,
  getPopulateDropdownsRequest,
} from './admin-user-role.endpoints';

import { addSystemNotice, addSpinner, removeSpinner } from '../../../slices/system/system.slice';
import {
  setStaff,
  setMembers,
  setUsernames,
} from '../../../slices/admin/user-role-management/user-role-management.slice';

export function* performViewStaffRequest({ payload }) {
  const { filters, onSuccess } = payload;

  try {
    yield put(addSpinner('Retrieving Staff'));

    const [endpoint, options] = getViewStaffRequest(filters);

    const { data } = yield call(axios, endpoint, options);

    if (onSuccess) {
      yield call(onSuccess, data.totalNumberOfAccounts);
    }

    yield put(setStaff(data.staffList));
  } catch (error) {
    yield put(setStaff([]));
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner('Retrieving Staff'));
  }
}

export function* watchForViewStaffRequest() {
  yield takeLeading(requestViewStaff.type, performViewStaffRequest);
}

export function* performUpdateUserGroupsRequest({ payload }) {
  const { input, onSuccess } = payload;

  try {
    yield put(addSpinner('Updating User Groups'));

    const [endpoint, options] = getUpdateUserGroupsRequest(input);

    const { data } = yield call(axios, endpoint, options);

    if (onSuccess) {
      yield call(onSuccess);
    }

    yield put(addSystemNotice({ type: SUCCESS, message: data.message }));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner('Updating User Groups'));
  }
}

export function* watchForUpdateUserGroupsRequest() {
  yield takeLeading(requestUpdateUserGroups.type, performUpdateUserGroupsRequest);
}

export function* performPopulateDropdownsRequest() {
  try {
    yield put(addSpinner('Retrieving members and usernames'));

    const [endpoint, options] = getPopulateDropdownsRequest();

    const { data } = yield call(axios, endpoint, options);

    yield put(setMembers(data.members));
    yield put(setUsernames(data.usernames));
  } catch (error) {
    yield put(setMembers([]));
    yield put(setUsernames([]));
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  } finally {
    yield put(removeSpinner('Retrieving members and usernames'));
  }
}

export function* watchForPopulateDropdownsRequest() {
  yield takeLeading(requestPopulateDropdowns.type, performPopulateDropdownsRequest);
}

export default function* adminUserRoleManagementSaga() {
  yield all([watchForViewStaffRequest(), watchForUpdateUserGroupsRequest(), watchForPopulateDropdownsRequest()]);
}
